<template>
  <div class="br-range-slider">
    <div :id="'slider_' + _uid"/>
  </div>
</template>

<style>
  .noUi-target {
    box-shadow: none;
    border: 0;
  }
</style>

<script>
import numeral from 'numeral'
import noUiSlider from 'nouislider'

export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: () => ({
    slider: null,
    isSliding: false,
    model: 0
  }),
  watch: {
    min () {
      this.slider.destroy()

      this.initSlider()
    },
    model (value) {
      this.$emit('input', numeral(value).value())

      if (!this.isSliding) {
        this.slider.set(numeral(value).value())
      }
    },
    value (value) {
      this.model = numeral(value).format('0,0')
    }
  },
  created () {
    this.model = numeral(this.value).format('0,0')
  },
  mounted () {
    this.initSlider()
  },
  methods: {
    initSlider () {
      const self = this

      let range = {
        min: [5000],
        '13%': [10000, 100],
        '18%': [15000, 100],
        '23%': [20000, 100],
        '28%': [25000, 100],
        '33%': [30000, 100],
        '38%': [35000, 100],
        '43%': [40000, 100],
        '48%': [45000, 100],
        '53%': [50000, 100],
        '58%': [100000, 1000],
        '63%': [150000, 1000],
        '68%': [200000, 1000],
        '73%': [300000, 1000],
        '78%': [350000, 1000],
        '83%': [400000, 1000],
        '88%': [450000, 1000],
        max: [500000]
      }

      const pips = {
        mode: 'range',
        density: 10,
        stepped: true
      }

      if (self.type === 'size') {
        range = {
          min: [self.min],
          '13%': [10000, 500],
          '18%': [15000, 500],
          '23%': [20000, 500],
          '28%': [25000, 500],
          '33%': [30000, 500],
          '38%': [35000, 500],
          '43%': [40000, 500],
          '48%': [45000, 500],
          '53%': [50000, 500],
          '58%': [70000, 1000],
          '63%': [90000, 1000],
          '68%': [100000, 1000],
          '73%': [120000, 1000],
          '78%': [140000, 1000],
          '83%': [200000, 1000],
          max: [250000]
        }

        pips.format = {
          to (value) {
            let formattedValues

            if (self.min === 1000) {
              formattedValues = {
                1000: '1k',
                10000: '&nbsp;',
                15000: '&nbsp;',
                20000: '&nbsp;',
                25000: '&nbsp;',
                30000: '&nbsp;',
                35000: '&nbsp;',
                40000: '&nbsp;',
                45000: '&nbsp;',
                50000: '&nbsp;',
                70000: '&nbsp;',
                90000: '&nbsp;',
                100000: '&nbsp;',
                120000: '&nbsp;',
                140000: '&nbsp;',
                150000: '&nbsp;',
                160000: '&nbsp;',
                170000: '&nbsp;',
                180000: '&nbsp;',
                190000: '&nbsp;',
                200000: '&nbsp;',
                250000: '250k'
              }
            }

            if (self.min === 4000) {
              formattedValues = {
                4000: '4k',
                10000: '&nbsp;',
                15000: '&nbsp;',
                20000: '&nbsp;',
                25000: '&nbsp;',
                30000: '&nbsp;',
                35000: '&nbsp;',
                40000: '&nbsp;',
                45000: '&nbsp;',
                50000: '&nbsp;',
                70000: '&nbsp;',
                90000: '&nbsp;',
                100000: '&nbsp;',
                120000: '&nbsp;',
                140000: '&nbsp;',
                150000: '&nbsp;',
                250000: '> 250k'
              }
            }

            if (self.min === 10000) {
              formattedValues = {
                10000: '10k',
                15000: '&nbsp;',
                20000: '&nbsp;',
                25000: '&nbsp;',
                30000: '&nbsp;',
                35000: '&nbsp;',
                40000: '&nbsp;',
                45000: '&nbsp;',
                50000: '&nbsp;',
                70000: '&nbsp;',
                90000: '&nbsp;',
                100000: '&nbsp;',
                120000: '&nbsp;',
                140000: '&nbsp;',
                150000: '&nbsp;',
                160000: '&nbsp;',
                170000: '&nbsp;',
                180000: '&nbsp;',
                190000: '&nbsp;',
                200000: '&nbsp;',
                250000: '250k'
              }
            }

            return formattedValues[value]
          }
        }
      }

      if (self.type === 'vbc') {
        pips.format = {
          to (value) {
            const formattedValues = {
              250: '250',
              10000: '&nbsp;',
              15000: '&nbsp;',
              20000: '&nbsp;',
              25000: '&nbsp;',
              30000: '&nbsp;',
              35000: '&nbsp;',
              40000: '&nbsp;',
              45000: '&nbsp;',
              50000: '&nbsp;',
              70000: '&nbsp;',
              90000: '&nbsp;',
              100000: '&nbsp;',
              120000: '&nbsp;',
              140000: '&nbsp;',
              150000: '&nbsp;',
              200000: '&nbsp;',
              300000: '&nbsp;',
              350000: '&nbsp;',
              400000: '&nbsp;',
              450000: '&nbsp;',
              500000: '500k'
            }

            return formattedValues[value]
          }
        }
      }

      if (self.type === 'email') {
        pips.format = {
          to (value) {
            const formattedValues = {
              5000: '5k',
              10000: '&nbsp;',
              15000: '&nbsp;',
              20000: '&nbsp;',
              25000: '&nbsp;',
              30000: '&nbsp;',
              35000: '&nbsp;',
              40000: '&nbsp;',
              45000: '&nbsp;',
              50000: '&nbsp;',
              100000: '&nbsp;',
              150000: '&nbsp;',
              200000: '&nbsp;',
              300000: '&nbsp;',
              350000: '&nbsp;',
              400000: '&nbsp;',
              450000: '&nbsp;',
              500000: '&nbsp;',
              5000000: '5M'
            }

            return formattedValues[value]
          }
        }
      }

      if (this.min && this.type !== 'size') {
        range = {
          min: [this.min],
          '13%': [10000, 100],
          '18%': [15000, 100],
          '23%': [20000, 100],
          '28%': [25000, 100],
          '33%': [30000, 100],
          '38%': [35000, 100],
          '43%': [40000, 100],
          '48%': [45000, 100],
          '53%': [50000, 100],
          '58%': [100000, 1000],
          '63%': [150000, 1000],
          '68%': [200000, 1000],
          '73%': [300000, 1000],
          '78%': [350000, 1000],
          '83%': [400000, 1000],
          '88%': [450000, 1000],
          max: [this.max]
        }
      }

      this.slider = noUiSlider.create(document.getElementById('slider_' + this._uid), {
        start: this.min ? this.min : 50000,
        snap: false,
        connect: [true, false],
        range,
        pips
      })

      this.slider.set(this.model)

      document.getElementById('slider_' + this._uid).noUiSlider.on('slide', (values, handle) => {
        this.isSliding = true
        this.model = numeral(values[0]).format('0,0')

        setTimeout(() => {
          this.isSliding = false
        }, 20)
      })
    }
  }
}
</script>
